import { styled, useTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  Box,
  IconButton,
  TableFooter,
  Tooltip,
  TablePagination,
  Chip,
  CircularProgress,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => onPageChange(event, 0);
  const handleBackButtonClick = (event) => onPageChange(event, page - 1);
  const handleNextButtonClick = (event) => onPageChange(event, page + 1);
  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="Primera página"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="Página anterior"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Siguiente página"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="Última página"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const TableComponent = ({
  data = [],
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  handleConsultConcept,
  formatter,
  handleUpdateQuantity,
  setNotification
}) => {
  const dataCount = data.filter((row) => row.show).length;
  const dataDisplay =
    rowsPerPage === -1
      ? data
      : data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "50%" }} align="center">Concepto</TableCell>
            <TableCell sx={{ width: "15%" }} align="center">Tipo</TableCell>
            <TableCell sx={{ width: "10%" }} align="center">Importe</TableCell>
            <TableCell sx={{ width: "15%" }} align="center">Cantidad</TableCell>
            <TableCell sx={{ width: "10%" }} align="center">Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataDisplay.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={5}
                align="center"
                sx={{ py: 3, color: "gray" }}
              >
                No se encontraron conceptos disponibles.
              </TableCell>
            </TableRow>
          ) : (
            dataDisplay
              .filter((row) => row.show)
              .map((row, index) => (
                <StyledTableRow key={row.internalId || index}>
                  <TableCell align="left" sx={{ fontSize: "12px" }}>
                    {row.TEXTO_CONCEPTO}
                  </TableCell>
                  <TableCell align="center">{row.CL_IMPORTE}</TableCell>
                  <TableCell align="center">
                    {formatter.format(Number(row.IMPORTE) || 0)}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={() =>
                        handleUpdateQuantity(row.internalId, "increment")
                      }
                    >
                      <AddIcon />
                    </IconButton>
                    <Chip label={row.CANTIDAD} variant="outlined" />
                    <IconButton
                      onClick={() =>
                        handleUpdateQuantity(row.internalId, "decrement")
                      }
                    >
                      <RemoveIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    {row.loading ? (
                      <CircularProgress size={24} sx={{ color: "var(--main-color-vino)" }} />
                    ) : (
                      <Tooltip title="Agregar">
                        <IconButton onClick={() => handleConsultConcept(row, setNotification)}>
                          <AddBoxIcon
                            sx={{ color: "var(--main-color-vino)" }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell>
                </StyledTableRow>
              ))
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[
                10,
                25,
                50,
                100,
                { label: "Todo", value: -1 },
              ]}
              colSpan={5}
              count={dataCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage="Registros por página:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}–${to} de ${count !== -1 ? count : `más de ${to}`}`
              }
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};
